var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-alert',{attrs:{"title":_vm.title,"type":_vm.type,"show-icon":""},on:{"close":_vm.close}},[_vm._t("description",function(){return [_vm._v(_vm._s(_vm.description))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }